import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { ORGANISATION_COMMUNITIES_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const OrganisationCommunitiesService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_COMMUNITIES_RESOURCE,
      method: 'get',
      request: organisationId => ({
        url: addParametersToUri(apiRoutes.getCommunities(organisationId), { organisationId }),
        clearValueOnRequest: true,
        meta: { organisationId },
      }),
    },
  ])(ComposedComponent);

export default OrganisationCommunitiesService;
